import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';

import * as actions from './user-data.actions';
import { UserDataState } from './user-data.reducer';
import { userDataState } from './user-data.selector';

@Injectable({
    providedIn: 'root',
})
export class UserDataService {
    constructor(
        private store: Store<UserDataState>,
        private actions$: Actions
    ) {}

    userData$ = this.store.pipe(select(userDataState));

    public setUsername(value: string) {
        this.store.dispatch(new actions.SetUserName({ username: value }));
    }

    public setFullname(value: string) {
        this.store.dispatch(new actions.SetFullUserName({ username: value }));
    }
}
